import upperFirst from 'lodash/upperFirst';

export const PRODUCTION_TYPES = ['season', 'film', 'other'];

export const PRODUCTION_TYPES_CUSTOM_LABELS = { youtube: 'YouTube' };

export const PRODUCTION_TYPES_URL_MAPPING = [
  {
    name: 'instagram',
    regex: /^(https?:\/\/)?(www\.)?(instagram\.com)\/.*$/i,
    usernameRegex: /^(?:https?:\/\/)?(?:www\.)?(?:instagram\.com)\/([^/]*)(?:\/?)(?:[^/]*?)$/i,
    channel: 'digital',
    type: 'instagram',
  },
];

export const PRODUCTION_TYPES_URL_MAPPING_BY_KEY = PRODUCTION_TYPES_URL_MAPPING.reduce(
  (acc, el) => {
    const newAcc = { ...acc };
    newAcc[el.name] = el;
    return newAcc;
  },
  {},
);

export const PRODUCTION_TYPES_OPTIONS = PRODUCTION_TYPES.map((value) => ({
  value,
  label: PRODUCTION_TYPES_CUSTOM_LABELS[value] || upperFirst(value),
}));

export const PRODUCTION_TYPE_ICONS = {
  season: 'tv',
  film: 'film',
  other: 'folder_open',
};
